import { render, staticRenderFns } from "./hrd-accreditor-detail.vue?vue&type=template&id=96fd0d0a&scoped=true"
import script from "./hrd-accreditor-detail.vue?vue&type=script&lang=js"
export * from "./hrd-accreditor-detail.vue?vue&type=script&lang=js"
import style0 from "./hrd-accreditor-detail.vue?vue&type=style&index=0&id=96fd0d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fd0d0a",
  null
  
)

export default component.exports